import React from "react";
import { useState } from "react";
import { writeContract, getNetwork } from '@wagmi/core'
import { getArticleNFTAddress } from '../../constants/addressBook'
import articleNFTABI from '../../abis/articleNFTABI'
import { adminRole } from "../../constants/roles";

export const RemoveAdminArticleNFT
: React.FC = () => {
  const [newAdmin, setnewAdmin] = useState("");

  return (
    <div>
      <label>Remove an Admin Permission
      <form>
        <label>New Admin
          <input
            type="text" 
            value={newAdmin}
            onChange={(e) => setnewAdmin(e.target.value)}
          />
        </label>
      </form>
      <button onClick={async () => {
        const network = await getNetwork()
        console.log(network.chain?.name)
        const articleNFTAddress = getArticleNFTAddress(network.chain?.name)
        writeContract({
          address: articleNFTAddress,
          abi: articleNFTABI,
          functionName: "revokeRole",
          args: [adminRole, newAdmin]
        })
      }}>Submit</button>
      </label>
      <br/>
      <br/>
    </div>
  )
}